/* eslint-disable no-undef */

window.Wized = window.Wized || [];
window.Wized.push(async (Wized) => {
  // playlist functionality
  const user = await Wized.requests.waitFor('get_user');
  const userAdmin = user.data.is_admin;
  let selectedPlaylistPrevEl = null;
  let selectedPlaylistName = null;
  let selectedPlaylistInformation = null;

  const mediaArtists = user.data.study_group.media.calm[0].category_items;
  let currentPreviewMedia = null;

  // get the templates and clone them
  const playlistCardReviewTemplate = document.getElementsByTagName('template')[2];
  const playlistViewTemplate = document.getElementsByTagName('template')[0];
  const playlistViewItemTemplate = document.getElementsByTagName('template')[1];
  const playlistCardSelectionTemplate = document.getElementsByTagName('template')[3];
  const playlistSelectedCardTemplate = document.getElementsByTagName('template')[4];

  const playlistReviewContainer = document.querySelector('[data-name="playlist-review-container"]');
  const playlistSelectionContainer = document.querySelector(
    '[data-name="playlist-selection-container"]'
  );
  const playlistPracticeContainer = document.querySelector(
    '[data-name="playlist-practice-container"]'
  );
  //playlist preview section

  const handleVideoPreviewMedia = (
    playlist,
    button,
    player,
    videoWrapper,
    itemWrapper,
    modalCloseButton
  ) => {
    modalCloseButton.addEventListener('click', () => {
      player.src = '';
      videoWrapper.style.display = 'none';
      itemWrapper.style.display = 'flex';
    });
    videoWrapper.style.display = 'block';
    itemWrapper.style.display = 'none';
    [currentPreviewMedia] = playlist.files;
    player.src = currentPreviewMedia.preview_url;
    player.play();
    currentPreviewButton = button;
  };

  const createPlaylistPreviewItem = (
    playlistViewContainer,
    modal,
    playlistCategories,
    category,
    modalCloseButton
  ) => {
    const playlists = playlistCategories
      .map((category) => {
        return category.playlist;
      })
      .flat(Infinity);
    const playlistViewItem = playlistViewItemTemplate.content.cloneNode(true);
    const playlistView = playlistViewTemplate.content.cloneNode(true);
    playlistView.querySelector('[data-name="playlist-card-title-heading"]').textContent =
      category.category_item_name;
    playlistView.querySelector('[data-name="playlist-card-title-tagline"]').textContent =
      category.category_item_info;
    playlistView.querySelector('[data-name="playlist-card-image"]').src =
      category.category_item_thumbnail.url;
    const playlistViewItemContainer = playlistView.querySelector(
      '[data-name="playlist-view_list"]'
    );
    playlistViewContainer.appendChild(playlistView);
    playlists.forEach((playlist) => {
      const previewVideoPlayer = playlistViewItem.querySelector('[data-name="preview-video"]');
      if (userAdmin) {
        new Plyr(previewVideoPlayer);
      } else {
        new Plyr(previewVideoPlayer, {
          controls: ['play', 'fullscreen'],
        });
      }
      const previewVideoPlayerWrapper = playlistViewItem.querySelector(
        '[data-name="video-wrapper"]'
      );
      const previewItemWrapper = playlistViewItem.querySelector(
        '[data-name="preview-view-list-wrapper"]'
      );

      playlistViewItem
        .querySelector('[data-name="playist-view_list_layout"]')
        .setAttribute('playlist-id', playlist.id);
      if (playlist.files.length > 0) {
        playlistViewItem.querySelector('[data-name="playlist-view-list-type"]').textContent =
          'Audio';
        playlistViewItem.querySelector('[data-name="playlist-view-list_image"]').style.display =
          'none';
        playlistViewItem.querySelector('[data-name="playlist-view-list-name"]').textContent =
          'Artist Sample';
        playlistViewItem
          .querySelector('[data-name="playlist-view-list-button"]')
          .addEventListener('click', function () {
            selectedPlaylist = playlist;
            handleVideoPreviewMedia(
              playlist,
              this,
              previewVideoPlayer,
              previewVideoPlayerWrapper,
              previewItemWrapper,
              modalCloseButton
            );
          });
        playlistViewItemContainer.appendChild(playlistViewItem);
      }
    });
  };

  const renderPlaylistReviewCards = () => {
    mediaArtists.forEach((category) => {
      const playlistCardReview = playlistCardReviewTemplate.content.cloneNode(true);
      const playlistContainer = playlistCardReview.querySelector(
        '[data-name="playlist-card-review_modalslot"]'
      );
      const button = playlistCardReview.querySelector('.modal_component .modal_button');
      const modalWrapper = playlistCardReview.querySelector('[data-name="modal_wrapper"]');
      const modalCloseButton = modalWrapper.querySelector('[data-name="modal-close-button"]');

      playlistCardReview.querySelector('[data-name="card-review-name"]').textContent =
        category.category_item_name;
      playlistCardReview.querySelector('[data-name="card-review-type"]').textContent =
        category.category_item_info;
      playlistCardReview.querySelector('[data-name="card-review-icon"]').src =
        category.category_item_thumbnail.url;
      createPlaylistPreviewItem(
        playlistContainer,
        playlistCardReview,
        category.playlist_categories,
        category,
        modalCloseButton
      );
      button.addEventListener('click', () => {
        openModal(button);
      });
      playlistReviewContainer.appendChild(playlistCardReview);
    });
  };
  renderPlaylistReviewCards();

  // playlist selection section

  const renderPlaylistSelectionCards = () => {
    mediaArtists.forEach((category) => {
      const playlistCardSelection = playlistCardSelectionTemplate.content.cloneNode(true);
      playlistCardSelection.querySelector('[data-name="card-review-name"]').textContent =
        category.category_item_name;
      playlistCardSelection.querySelector('[data-name="card-review-type"]').textContent =
        category.category_item_info;
      playlistCardSelection.querySelector('[data-name="card-review-icon"]').src =
        category.category_item_thumbnail.url;
      playlistCardSelection
        .querySelector('[data-name="playlist_selection_card"]')
        .setAttribute('playlist-name', category.category_item_name);

      playlistSelectionContainer.appendChild(playlistCardSelection);
    });
  };
  renderPlaylistSelectionCards();

  const confirmPlaylistButton = document.querySelector('[data-name="calm_confirm_playlist"]');
  confirmPlaylistButton.classList.add('is-disabled');

  const toggleSelectedPlaylist = (selectedPlaylistElement) => {
    selectedPlaylistElement.addEventListener('click', () => {
      if (selectedPlaylistElement.classList.contains('is-selected')) {
        selectedPlaylistElement.classList.remove('is-selected');
        selectedPlaylistPrevEl = null;
        selectedPlaylistName = null;
      } else {
        if (selectedPlaylistPrevEl) {
          selectedPlaylistPrevEl.classList.remove('is-selected');
        }
        selectedPlaylistElement.classList.add('is-selected');
        selectedPlaylistPrevEl = selectedPlaylistElement;
        selectedPlaylistName = selectedPlaylistElement.getAttribute('playlist-name');
        Wized.data.v.user_data = { selectedPlaylist: selectedPlaylistName };
      }
      if (selectedPlaylistName !== null) {
        confirmPlaylistButton.classList.remove('is-disabled');
      }
    });
  };

  const selectionCards = document.querySelectorAll('[data-name="playlist_selection_card"]');
  selectionCards.forEach((card) => {
    toggleSelectedPlaylist(card);
  });

  confirmPlaylistButton.addEventListener('click', async () => {
    selectedPlaylistInformation = mediaArtists.filter(
      (artist) => artist.category_item_name === selectedPlaylistName
    )[0];

    document.querySelector('[data-name="practice-card-review-icon"]').src =
      selectedPlaylistInformation.category_item_thumbnail.url;
    document.querySelector('[data-name="practice-card-review-name"]').textContent =
      selectedPlaylistInformation.category_item_name;
    document.querySelector('[data-name="practice-card-review-type"]').textContent =
      selectedPlaylistInformation.category_item_info;

    Wized.data.v.user_data = { selectedPlaylist: selectedPlaylistName };
    await Wized.requests.execute('update_user');
  });

  // document.addEventListener('practice-session-prep', async function () {
  //   document.querySelector('[data-name="practice-card-review-icon"]').src =
  //     selectedPlaylistInformation.category_item_thumbnail.url;
  //   document.querySelector('[data-name="practice-card-review-name"]').textContent =
  //     selectedPlaylistInformation.category_item_name;
  //   document.querySelector('[data-name="practice-card-review-type"]').textContent =
  //     selectedPlaylistInformation.category_item_info;
  // });

  //Charting Elements
  let chartClicks = 0;
  let startPoint = document.getElementById('startPoint');
  let endPoint = document.getElementById('endPoint');
  let finalStartPoint = document.getElementById('finalStartPoint');
  let finalEndPoint = document.getElementById('finalEndPoint');
  let finalPoint = document.getElementById('finalPoint');
  let startChartLine = document.getElementById('startChartLine');
  let finalChartLine = document.getElementById('finalChartLine');
  let chartingSessionComplete = false;
  const chartResetButton = document.getElementById('chartReset');
  const finalChartResetButton = document.getElementById('finalChartReset');
  chartResetButton.style.display = 'none'; // initially don't display reset button
  finalChartResetButton.style.display = 'none'; // initially don't display reset button

  var calm_meta = {
    start: {
      val: null,
      aro: null,
      quad: null,
    },
    end: {
      val: null,
      aro: null,
      quad: null,
    },
    final: {
      val: null,
      aro: null,
      quad: null,
    },
    stimuli: {
      endstate: null, //calm
      category: null, //classical
      type: null, // abilene
      name: null, //playlist name (abilene 15 min)
      files: null, //playlist files
    },
  };

  const chartingWrappers = document.querySelectorAll('.charting_plus-grid');

  chartingWrappers.forEach((chartWrapper) => {
    for (let i = 0; i < 19; i++) {
      for (let j = 0; j < 19; j++) {
        // Create the grid item container
        const gridItem = document.createElement('div');

        let quad;

        if (i >= 10 && j < 10) {
          quad = '3'; // Bottom-left quad
        } else if (i >= 10 && j >= 10) {
          quad = '4'; // Bottom-right quad
        } else if (i < 10 && j < 10) {
          quad = '1'; // Top-left quad
        } else if (i < 10 && j >= 10) {
          quad = '2'; // Top-right quad
        }

        // Set the quadrant attribute
        const val = j + 1; // Column number
        const aro = 19 - i; // Row number

        // If it's the very center div (intersection of the center row and center column)
        if (i === 9 && j === 9) {
          gridItem.setAttribute('val', val);
          gridItem.setAttribute('aro', aro);

          gridItem.classList.add('charting_plus-grid-split', 'is-center');

          const gridItemTopLeft = document.createElement('div');
          const gridItemTopRight = document.createElement('div');
          const gridItemBottomLeft = document.createElement('div');
          const gridItemBottomRight = document.createElement('div');

          gridItemTopLeft.setAttribute('val', val);
          gridItemTopLeft.setAttribute('aro', aro);
          gridItemTopLeft.setAttribute('quad', '1');

          gridItemTopRight.setAttribute('val', val);
          gridItemTopRight.setAttribute('aro', aro);
          gridItemTopRight.setAttribute('quad', '2');

          gridItemBottomLeft.setAttribute('val', val);
          gridItemBottomLeft.setAttribute('aro', aro);
          gridItemBottomLeft.setAttribute('quad', '3');

          gridItemBottomRight.setAttribute('val', val);
          gridItemBottomRight.setAttribute('aro', aro);
          gridItemBottomRight.setAttribute('quad', '4');

          gridItemTopLeft.classList.add('charting_plus-grid-item');
          gridItemTopRight.classList.add('charting_plus-grid-item');
          gridItemBottomLeft.classList.add('charting_plus-grid-item');
          gridItemBottomRight.classList.add('charting_plus-grid-item');

          gridItem.appendChild(gridItemTopLeft);
          gridItem.appendChild(gridItemTopRight);
          gridItem.appendChild(gridItemBottomLeft);
          gridItem.appendChild(gridItemBottomRight);
          chartWrapper.appendChild(gridItem);
        } else if (i === 9) {
          // If it's on the center row (X-axis), split the div into top and bottom
          gridItem.classList.add('charting_plus-grid-split', 'is-horzontal');

          const gridItemTop = document.createElement('div');
          const gridItemBottom = document.createElement('div');

          gridItemTop.classList.add('charting_plus-grid-item');
          gridItemBottom.classList.add('charting_plus-grid-item');

          gridItemTop.setAttribute('val', val);
          gridItemTop.setAttribute('aro', aro);

          gridItemBottom.setAttribute('val', val);
          gridItemBottom.setAttribute('aro', aro);

          if (j < 10) {
            gridItemTop.setAttribute('quad', '1');
            gridItemBottom.setAttribute('quad', '3');
          }

          if (j >= 10) {
            gridItemTop.setAttribute('quad', '2');
            gridItemBottom.setAttribute('quad', '4');
          }

          gridItem.appendChild(gridItemTop);
          gridItem.appendChild(gridItemBottom);

          chartWrapper.appendChild(gridItem);
        } else if (j === 9) {
          // If it's on the center column (Y-axis), split the div into left and right
          gridItem.classList.add('charting_plus-grid-split');

          const gridItemLeft = document.createElement('div');
          const gridItemRight = document.createElement('div');

          gridItemLeft.classList.add('charting_plus-grid-item');
          gridItemRight.classList.add('charting_plus-grid-item');

          gridItemLeft.setAttribute('val', val);
          gridItemLeft.setAttribute('aro', aro);

          gridItemRight.setAttribute('val', val);
          gridItemRight.setAttribute('aro', aro);

          if (i < 10) {
            gridItemLeft.setAttribute('quad', '1');
            gridItemRight.setAttribute('quad', '2');
          }

          if (i >= 10) {
            gridItemLeft.setAttribute('quad', '3');
            gridItemRight.setAttribute('quad', '4');
          }

          gridItem.appendChild(gridItemLeft);
          gridItem.appendChild(gridItemRight);

          chartWrapper.appendChild(gridItem);
        } else {
          // Normal grid item (not on the center row/column)
          gridItem.classList.add('charting_plus-grid-item');
          gridItem.setAttribute('quad', quad);
          gridItem.setAttribute('val', val);
          gridItem.setAttribute('aro', aro);

          chartWrapper.appendChild(gridItem);
        }
      }
    }
  });
  let calmQuadrant = document.querySelector('[val="14"][aro="5"]');

  //Charting Functions

  const resetStartGrid = () => {
    chartClicks = 0;
    startChartLine.innerHTML = '';
    chartResetButton.style.display = 'none';
    startPoint.style.display = 'none';
    endPoint.style.display = 'none';
    document.querySelectorAll("[quad='1']").forEach(function (element) {
      element.style.pointerEvents = 'auto';
    });
    document.querySelectorAll("[quad='3']").forEach(function (element) {
      element.style.pointerEvents = 'auto';
    });
    disableContinueButton();
  };

  const resetEndGrid = () => {
    chartClicks = 2;
    chartResetButton.style.display = 'none';
    finalPoint.style.display = 'none';
    finalChartResetButton.style.display = 'none';
    disableContinueButton();
  };

  const drawLine = (startPoint, endPoint, chartLine) => {
    chartLine.innerHTML = '';
    let line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    line.setAttribute('x1', startPoint.style.left);
    line.setAttribute('y1', startPoint.style.top);
    line.setAttribute('x2', endPoint.style.left);
    line.setAttribute('y2', endPoint.style.top);
    line.setAttribute('stroke', '#E7E1D1');
    line.setAttribute('stroke-width', '2');
    chartLine.appendChild(line);
  };

  // general functionality

  function getElementPosition(element) {
    if (!element) return null;

    const rect = element.getBoundingClientRect();

    return {
      x: rect.left + rect.width / 2,
      y: rect.top + rect.height / 2,
    };
  }

  const gridPoints = document.querySelectorAll('.charting_plus-grid-item');
  gridPoints.forEach((gridPoint) => {
    gridPoint.addEventListener('click', async function (event) {
      const calmQuadrantPosition = getElementPosition(calmQuadrant);
      if (chartClicks !== 3) {
        chartClicks += 1;
      }
      let parentRect;
      if (event.currentTarget.parentElement.classList[0] === 'charting_plus-grid-split') {
        parentRect = event.currentTarget.parentElement.parentElement.getBoundingClientRect();
      } else {
        parentRect = event.currentTarget.parentElement.getBoundingClientRect();
      }
      let x = event.clientX - parentRect.left;
      let y = event.clientY - parentRect.top;
      if (chartClicks === 1) {
        disableContinueButton();
        startPoint.style.display = 'block';
        startPoint.style.left = x + 'px';
        startPoint.style.top = y + 'px';
        startPoint.style.zIndex = '2';
        endPoint.style.display = 'block';
        endPoint.style.left = calmQuadrantPosition.x - parentRect.left + 'px';
        endPoint.style.top = calmQuadrantPosition.y - parentRect.top + 'px';
        endPoint.style.zIndex = '1';
        endPoint.classList.add('is-selected');
        calm_meta.start.val = gridPoint.getAttribute('val');
        calm_meta.start.aro = gridPoint.getAttribute('aro');
        calm_meta.start.quad = gridPoint.getAttribute('quad');
        calm_meta.end.val = calmQuadrant.getAttribute('val');
        calm_meta.end.aro = calmQuadrant.getAttribute('aro');
        calm_meta.end.quad = calmQuadrant.getAttribute('quad');
        chartResetButton.style.display = 'block';
        // disableGrids();
        drawLine(startPoint, endPoint, startChartLine);
        enableContinueButton();

        // final start point styling
        finalStartPoint.style.left = startPoint.style.left;
        finalStartPoint.style.top = startPoint.style.top;
        finalStartPoint.style.zIndex = startPoint.style.zIndex;
        finalStartPoint.style.display = 'block';
        finalStartPoint.style.opacity = '0.40';

        // final end point styling
        finalEndPoint.style.left = endPoint.style.left;
        finalEndPoint.style.top = endPoint.style.top;
        finalEndPoint.style.zIndex = endPoint.style.zIndex;
        finalEndPoint.style.display = 'block';
        finalEndPoint.style.opacity = '0.40';
        finalChartLine.style.opacity = '0.50';

        sessionStorage.setItem('finalStartPointLeft', startPoint.style.left);
        sessionStorage.setItem('finalStartPointTop', startPoint.style.top);
        sessionStorage.setItem('finalStartPointZIndex', startPoint.style.zIndex);
        sessionStorage.setItem('finalEndPointLeft', endPoint.style.left);
        sessionStorage.setItem('finalEndPointTop', endPoint.style.top);
        sessionStorage.setItem('finalEndPointZIndex', endPoint.style.zIndex);

        drawLine(finalStartPoint, finalEndPoint, finalChartLine);
        chartingSessionComplete = true;
        chartClicks = 2;
      }
      if (chartingSessionComplete && chartClicks === 3) {
        finalPoint.style.display = 'block';
        finalPoint.style.left = x + 'px';
        finalPoint.style.top = y + 'px';
        finalPoint.style.zIndex = '2';
        calm_meta.final.val = gridPoint.getAttribute('val');
        calm_meta.final.aro = gridPoint.getAttribute('aro');
        calm_meta.final.quad = gridPoint.getAttribute('quad');
        finalChartResetButton.style.display = 'block';
        enableContinueButton();
      }
    });
  });

  chartResetButton.addEventListener('click', async () => {
    resetStartGrid();
  });

  finalChartResetButton.addEventListener('click', async () => {
    resetEndGrid();
  });
  // end charting logic

  //practice session logic
  const startSessionButton = document.querySelector('[data-name="calm_confirm_practice_session"]');
  startSessionButton.addEventListener('click', async () => {
    const practiceAudioPlayer = document.querySelector(
      '[data-name="practice_session_audio_player"]'
    );
    document.querySelector('[data-name="practice_session_audio_title"]').textContent =
      `${selectedPlaylistName} Demo`;
    const practiceAudioPlayerWrapper = document.querySelector(
      '[data-name="practice_audio_wrapper"]'
    );
    const practiceVideoPlayer = document.querySelector('[data-name="practice_session_video"]');
    let videoPlyr = {};
    if (userAdmin) {
      videoPlyr = new Plyr('[data-name="practice_session_video"]');
      new Plyr(practiceAudioPlayer);
    } else {
      videoPlyr = new Plyr('[data-name="practice_session_video"]', {
        controls: ['play', 'fullscreen'],
      });
      new Plyr(practiceAudioPlayer, {
        controls: ['play'],
      });
    }

    const handlePracticeMedia = (practiceMedia) => {
      if (practiceMedia.type === 'video') {
        practiceVideoPlayer.src = practiceMedia.url;
        practiceAudioPlayerWrapper.style.display = 'none';
        practiceVideoPlayer.style.display = 'block';
        practiceVideoPlayer.load();
        practiceVideoPlayer.play();
        practiceVideoPlayer.onended = () => {
          enableContinueButton();
        };
      } else {
        practiceAudioPlayer.src = practiceMedia.url;
        practiceVideoPlayer.style.display = 'none';
        practiceAudioPlayer.style.display = 'block';
        practiceAudioPlayer.load();
        practiceAudioPlayer.play();
        practiceAudioPlayer.onended = () => {
          enableContinueButton();
        };
      }
    };
    handlePracticeMedia(selectedPlaylistInformation.practice_media);
  });
});
